<!--
Il contenuto della page viene appoggiato qui per poi iniettarlo 
nel ngTemplateOutlet del div "pageBody"
-->
<ng-template #pageBodyContent>
  <ng-content select="[slot=page]"></ng-content>
</ng-template>

<div style="height: 100%; width: 100%;"
     [ngStyle]="{'background-image': 'url(' + canvasLayoutDataService.bgUrl + ')'}">
  <ng-container> 
    <!--
    NOTA: min-height: 100% (e non height: 100%) è determinante per far funzionare le ancore nella pagina
    -->
    <mat-sidenav-container [dir]="localeDataService.direction" 
                           style="min-height: 100%; background-color: white;" 
                           (backdropClick)="canvasLayoutDataService.closeSidenav1()">
      <!--
      SIDENAV
      -->
      <mat-sidenav #sidenav canvasLayoutDataService
                  [mode]="canvasLayoutDataService.sidenav1Mode" 
                  [opened]="canvasLayoutDataService.isSidenav1Open" 
                  class="sidenav"
                  [fixedInViewport]="true">
        <ng-content select="[slot=side1]"></ng-content>
      </mat-sidenav>
      <!--
      HEADER
      -->
      <div id="header" style="position: fixed; z-index: 999;" [ngStyle]="{'width': canvasLayoutDataService.workingWidth+'px'}">
        <ng-content select="[slot=header]"></ng-content>
      </div>
      <!--
      BODY
      -->
      <mat-sidenav-container style="background-color: transparent;">
        <!--
        SIDENAV2
        -->
        <mat-sidenav #sidenav2 
                     position="end"
                     [mode]="canvasLayoutDataService.sidenav2Mode" 
                     [opened]="canvasLayoutDataService.isSidenav2Open" 
                     class="sidenav2"
                     [fixedInViewport]="true"
                     [fixedTopGap]="canvasLayoutDataService.headerHeight">
          <ng-content select="[slot=side2]"></ng-content>
        </mat-sidenav>
        <!--
        PAGE CONTENT
          NOTA: min-height: 100% (e non height: 100%) è determinante per far funzionare le ancore nella pagina
        -->
        <div id="viewport" [ngStyle]="{'min-height': canvasLayoutDataService.viewportHeight+'px'}">
          <!--Questo div resta dietro l'header fisso (che rimane su un layer superiore) e serve per spingere più in basso i contenuti, 
              in modo che non rimangano coperti dall'header-->
          <div id="headerPlaceholder" [ngStyle]="{'height': canvasLayoutDataService.headerHeight+'px'}"></div>
          <div id="page"
               class="layout vertical center"
               [ngStyle]="{'height': canvasLayoutDataService.pageBodyHeight <= (canvasLayoutDataService.viewportHeight-canvasLayoutDataService.headerHeight) 
                                     ? (canvasLayoutDataService.viewportHeight-canvasLayoutDataService.headerHeight)+'px' : null}"
               [ngClass]="{'middle': pageLayoutDataService.verticallyCentered && canvasLayoutDataService.pageBodyHeight <= (canvasLayoutDataService.viewportHeight-canvasLayoutDataService.headerHeight)}">
            <div id="pageBody" 
                 style="width: 100%; background-color: transparent;"
                 (resized)="onPageBodyResize($event)">
              <!--
              Page layout in cui viene iniettato il contenuto della page, appoggiato a riga 5
              -->
              <app-page-layout-new [content]="pageBodyContent"></app-page-layout-new>
            </div>
          </div>
        </div>
      </mat-sidenav-container>
    </mat-sidenav-container>
  </ng-container>
</div>
